import Button from 'components/Button';
import CustomVideo from 'components/CustomVideo';
import Layout from 'components/Layout';
import RecentBlogPosts from 'components/RecentBlogPosts';
import RecentPodcasts from 'components/RecentPodcasts';
import SEO from 'components/seo';
import ServicesCTA from 'components/ServicesCTA';
import CTAWithImageRightBtn from 'containers/CTAWithImageRightBtn';
import HeroSection from 'containers/HeroSection';
import TestimonialsSection from 'containers/TestimonialsSection';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import {
  SHeroTitle,
  SPaddedSection,
  SSectionTitle,
  SSplitSectionWithImage,
  STitle,
} from './styles';

import AffiliationsSection from 'containers/AffiliationsSection';
import LandingFAQ from 'components/LandingFAQ';
import { home_faqs } from 'data_jsons/home_faq';

const IndexPage = ({ pageContext }) => {
  return (
    <Layout
      navType="light"
      navLinkType={'light'}
      navBgColor="#ffffff"
      navLinkColor="#ffffff"
      logoType={'light'}
    >
      <SEO
        title="Oasis Living | Online Letting Agents & Property Management London"
        description="Oasis Living is an online property management and lettings company offering multiple flats to rent in London. Lettings made easy and for landlords & tenants."
        useTitleTemplate={false}
      />
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>
      <HeroSection
        // welcomeTitle="Welcome To Oasis Living"
        mainTitle={
          <SHeroTitle>
            Improve your <br />
            <span className="highlight">property letting experience</span>
          </SHeroTitle>
        }
        subTitle={
          <>
            Forget the high street letting agencies and make your next move with
            Oasis Living; an online letting agency that uses tech and automation
            to improve the letting process{' '}
            <Link to="/list-property/">for both landlords and tenants.</Link>
          </>
        }
        actions={
          <>
            <Button
              className="mr-md-2 mb-2"
              margin="10px"
              $backgroundColor="accent"
              variant="full"
              $withArrow={true}
              onClick="/tenant/"
              buttonID="home-page-list-your-property-hero"
            >
              I am a Tenant
            </Button>
            <Button
              margin="10px"
              className="mb-2"
              variant="full"
              $withArrow={true}
              buttonID="home-page-view-properties-hero"
              onClick="/landlord/"
            >
              I am a Landlord
            </Button>
          </>
        }
        slug={<>OASIS LIVING</>}
        backgroundImage={'landlord_home/header_image.jpg'}
      />

      <SSplitSectionWithImage
        $overflow="hidden"
        imageName="homepage/who-are-we.jpg"
        alignChildren={false}
        starSvgMoveLeft="245px"
        starSvgMoveY={'-100px'}
        starSvgZInxdex={100}
        background="alice_blue_2"
        containerPadding="100px 0"
        margin={'0'}
        showAffiliations={true}
      >
        <ServicesCTA
          mode="dark"
          titleChildren={
            <SPaddedSection>
              <SSectionTitle
                subTitle="Oasis Living"
                title={
                  <STitle $inverted={false}>
                    Who are we?
                    {/* <span className="highlight">{titleHighlight}</span> */}
                  </STitle>
                }
              />
            </SPaddedSection>
          }
          description={
            <SPaddedSection>
              At Oasis Living, we believe that letting a property in today’s
              world should be as easy as ordering fried chicken to your front
              door. Traditional lettings agents rely on old technology to
              conduct their business, meaning landlords and renters end up
              paying for a sub-optimal service that doesn’t fully meet their
              needs.
              <br /> <br />
              We understand landlords need transparency when it comes to their
              properties and that tenants need efficiency when moving in and
              raising issues. We are an online letting agency that solves these
              problems using automated systems and an online dashboard.
            </SPaddedSection>
          }
          actionChildren={
            <SPaddedSection>
              <Button
                margin="2em 0"
                $backgroundColor="accent"
                variant="full"
                $withArrow={true}
                onClick="/landlord/tenant-find/"
                buttonID="build-to-rent-tenant-find-perfect"
              >
                Find Out More
              </Button>
            </SPaddedSection>
          }
        />
      </SSplitSectionWithImage>

      <AffiliationsSection $isWhite={false} $backgroundColor="#F2F7FE" />

      <CustomVideo
        content="Hear our Founder, Sam Ghosh, and other key members of the Oasis Living team, talk about why they think landlords and tenants will benefit from using our online letting service."
        title="Our vision"
        titleHighlight="for a better letting experience"
        placeholder={'homepage/video.jpg'}
        videoId={'YmDtDx1l9Bw'}
      />
      <SSplitSectionWithImage
        $overflow="hidden"
        mode="dark"
        isImageLeft
        imageName="homepage/landlords.png"
        alignChildren={false}
        padding={true}
        starSvgMoveLeft="765px"
        starSvgMoveY={'-100px'}
        containerPadding="100px 0"
        starSvgZInxdex={100}
        margin="0"
        showOverlayImage={true}
      >
        <ServicesCTA
          titleChildren={
            <SPaddedSection>
              <SSectionTitle
                subTitle=""
                title={
                  <STitle $inverted={true}>
                    Landlords, this is the{' '}
                    <span className="highlight">
                      level of service you deserve
                    </span>
                  </STitle>
                }
              />
            </SPaddedSection>
          }
          description={
            <SPaddedSection>
              With our dashboard and customer care team, you will never be in
              the dark again. We offer a fully transparent system where you can
              track rent payments, maintenance issues and more.
              <br /> <br /> We understand that your property is a HUGE asset for
              you and your family. That’s why we will never leave you waiting
              and wondering whether your documentation is being taken care of.
              Just open the dashboard and BOOM, you’re up to date
            </SPaddedSection>
          }
          actionChildren={
            <SPaddedSection>
              <Button
                margin="2em 0"
                $backgroundColor="accent"
                variant="full"
                $withArrow={true}
                onClick="/build-to-rent"
                buttonID="build-to-rent-tenant-find-perfect"
              >
                Visit build to rent page
              </Button>
            </SPaddedSection>
          }
        />
      </SSplitSectionWithImage>

      <SSplitSectionWithImage
        $overflow="hidden"
        background="alice_blue_2"
        isImageLeft
        imageName="homepage/add-more-joy.png"
        alignChildren={false}
        padding={true}
        starSvgMoveLeft="765px"
        starSvgMoveY={'-118px'}
        containerPadding="100px 0"
        margin="0"
        starSvgZInxdex={100}
      >
        <ServicesCTA
          mode="dark"
          titleChildren={
            <SPaddedSection>
              <SSectionTitle
                subTitle=""
                title={
                  <STitle>
                    Add more joy to{' '}
                    <span className="highlight">
                      <br />
                      your next move{' '}
                    </span>
                  </STitle>
                }
              />
            </SPaddedSection>
          }
          description={
            <SPaddedSection>
              We all know that moving is a stressful ordeal. Your letting agent
              should not make it more difficult! With an online letting agent
              like Oasis Living, you’ll never have to wait around for an agent
              to answer your calls and emails
              <br />
              <br />
              If you are tired of being left on hold, passed from agent to agent
              and being told conflicting information, make a move to Oasis
              Living. We will make sure your move goes as quickly and smoothly
              as possible using our automated systems.
              <br />
              <br />
              What’s more, once you’re in the system, moving between Oasis
              living properties could not be easier! You’ve already added your
              details and documents. All you have to do is tell us where and
              when! Find a property.
              <br />
              <br />
              <strong>Get in Touch. Move-in</strong>
            </SPaddedSection>
          }
          actionChildren={
            <SPaddedSection>
              <Button
                margin="2em 0"
                $backgroundColor="accent"
                variant="full"
                $withArrow={true}
                onClick="/landlord"
                buttonID="build-to-rent-tenant-find-perfect"
              >
                Find out more
              </Button>
            </SPaddedSection>
          }
        />
      </SSplitSectionWithImage>

      <TestimonialsSection />

      <SSplitSectionWithImage
        $overflow="hidden"
        imageName="homepage/improved-letting.jpg"
        background="alice_blue_2"
        isImageLeft
        alignChildren={false}
        padding={true}
        starSvgMoveLeft="765px"
        starSvgMoveY={'-118px'}
        containerPadding="100px 0"
        margin="0"
        starSvgZInxdex={100}
      >
        <ServicesCTA
          mode="dark"
          titleChildren={
            <SPaddedSection>
              <SSectionTitle
                subTitle=""
                title={
                  <STitle>
                    Improved letting{' '}
                    <span className="highlight">
                      <br />
                      services for the busy landlord
                    </span>
                  </STitle>
                }
              />
            </SPaddedSection>
          }
          description={
            <SPaddedSection>
              We offer well known and understood letting agency services such as
              property management and tenant finding, with an automated
              supercharged upgrade. And, because our automation keeps overheads
              low, we won’t charge you as much in fees! An improved property
              letting service for less. What are you waiting for?
              <br /> <br />
              <strong>
                <a href="/">
                  An improved property letting service for less. What are you
                  waiting for?
                </a>
              </strong>
            </SPaddedSection>
          }
          actionChildren={
            <SPaddedSection>
              <Button
                margin="2em 0"
                $backgroundColor="accent"
                variant="full"
                $withArrow={true}
                onClick="/landlord"
                buttonID="build-to-rent-tenant-find-perfect"
              >
                Find out more
              </Button>
            </SPaddedSection>
          }
        />
      </SSplitSectionWithImage>

      <LandingFAQ data={home_faqs} />

      <RecentBlogPosts posts={pageContext.recentPosts} isSlider />

      <SSplitSectionWithImage
        $overflow="hidden"
        mode="dark"
        imageName="homepage/buy-to-let-01.png"
        alignChildren={false}
        padding={true}
        displayStarSvg={false}
        showOverlayImage={true}
        overlayImage="homepage/buy-to-let-02.png"
        showOverlaySVG={true}
        margin="0"
        containerPadding="100px 0"
      >
        <ServicesCTA
          titleChildren={
            <SPaddedSection>
              <SSectionTitle
                subTitle=""
                title={
                  <STitle $inverted={true}>
                    Buy-to-let? Build-to-rent?{' '}
                    <span className="highlight">
                      <u>We&rsquo;ve got it covered</u>{' '}
                    </span>
                  </STitle>
                }
              />
            </SPaddedSection>
          }
          description={
            <SPaddedSection>
              Whether you want to maximise your return on a buy-to-let or
              you&rsquo;re in the Build-to-Rent game, our services can improve
              your letting experience. With easy payment tracking and
              maintenance management through the dashboard, you&rsquo;re sure to
              see the benefits of our online letting service quickly.
              <br /> <br />
              We want to make finding tenants and managing property easier, no
              matter what kind of property you&rsquo;re into!
            </SPaddedSection>
          }
          actionChildren={
            <SPaddedSection>
              <Button
                margin="2em 0"
                $backgroundColor="accent"
                variant="full"
                $withArrow={true}
                onClick="/build-to-rent"
                buttonID="build-to-rent-tenant-find-perfect"
              >
                Visit build to rent page
              </Button>
            </SPaddedSection>
          }
        />
      </SSplitSectionWithImage>

      <RecentPodcasts podcasts={pageContext.recentPodcasts} />

      <CTAWithImageRightBtn
        mainText={
          <>
            Don’t settle for average, choose an online letting agent and{' '}
            <strong>
              <u>supercharge</u>
            </strong>{' '}
            your letting experience
          </>
        }
        filename="homepage/cta-background.jpg"
        description={
          <>
            Our agents are here to help you improve your property letting
            experience. <br />
            <br />
            <strong>
              <a href="/contact-us">Get in touch </a>
            </strong>
            today to find out more!
          </>
        }
      />
    </Layout>
  );
};

IndexPage.propTypes = {
  pageContext: PropTypes.object,
};

export default IndexPage;
